import React from 'react';

const STATUS_COLORS = {
  success: { bg: '#E8F5E9', text: '#45B116' },
  error: { bg: '#FFEBEE', text: '#f44336' },
  timeout: { bg: '#FFFBEB', text: '#FF9800' },
  archived: { bg: '#F5F5F5', text: '#757575' },
  parse_failed: { bg: '#FFEBEE', text: '#f44336' },
};

const StatusBadge = ({ status }) => {
  const colors = STATUS_COLORS[status] || { bg: '#F5F5F5', text: '#757575' };
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        backgroundColor: colors.bg,
        color: colors.text,
      }}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
